import React from 'react';
import { FormattedMessage } from 'react-intl';

export const ItemsCount = {
  getName: () => <FormattedMessage defaultMessage='Items' description='customerOrdersGrid.columns.itemsCount' id='9HM7j/' />,
  id: 'itemsCount',

  render: (data) => {
    const { items = [] } = data;
    return items.length;
  },
};
